import { useReduxSelector } from '../../../hooks'
import { RootState } from '../../../modules'
import { OfferState } from '../../../modules/flex2/offer'

export const useOffer: () => OfferState = () => useReduxSelector((state: RootState) => state.offerState)
